import { useEffect, useState } from 'react';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';

export function EnergyIndicator() {
  const [energy, setEnergy] = useState(100);
  const [maxEnergy, setMaxEnergy] = useState(100);

  const onPlayerSync = (message: Shared.PlayerSyncMessage) => {
    const id = useAppStore.getState().id;
    if (!id.startsWith(message.id)) return;
  
    setEnergy(message.energy);
    setMaxEnergy(message.maxEnergy);
  };

  useEffect(() => {
    Shared.MessageRegistry.emitter.on(Shared.PlayerSyncMessage.Opcode, onPlayerSync);
    return () => {
      Shared.MessageRegistry.emitter.off(Shared.PlayerSyncMessage.Opcode, onPlayerSync);
    };
  }, []);

  const width = `${energy / maxEnergy * 100}%`;

  return (
    <div className="h-1 bg-primary drop-shadow-primary" style={{ width }}>
      <p className="text-xs text-primary pt-[2px]">{energy}</p>
    </div>
  );
}
